import React from 'react';
import Form from '../../../../components/molecules/forms';
import Button from '../../../../components/molecules/buttons';

function FormsCompanyInfo(props: {formik : any, isLoading: boolean}): React.ReactElement {
  const { formik, isLoading } = props;
  return (
    <form
      aria-label="form"
      onSubmit={formik.handleSubmit}
      className="form-container"
    >
      <Form.Default
        id="companyName"
        label="Company Name"
        placeholder="Enter company name"
        value={formik.values.companyName}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.companyName && !!formik.errors.companyName}
        errorMsg={formik.errors.companyName}
        onBlur={formik.handleBlur}
        validation
      />
      <Form.Default
        id="streetAddress"
        label="Street Address"
        placeholder="Enter street address"
        value={formik.values.streetAddress}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.streetAddress && !!formik.errors.streetAddress}
        errorMsg={formik.errors.streetAddress}
        onBlur={formik.handleBlur}
        validation
      />
      <div className="row">
        <div className="col-lg-6">
          <Form.Default
            id="city"
            label="City"
            placeholder="Enter city"
            value={formik.values.city}
            onChange={formik.handleChange}
            className="mb-4"
            isInvalid={formik.touched.city && !!formik.errors.city}
            errorMsg={formik.errors.city}
            onBlur={formik.handleBlur}
            validation
          />
        </div>
        <div className="col-lg-6">
          <Form.Default
            id="state"
            label="State"
            placeholder="Enter state"
            value={formik.values.state}
            onChange={formik.handleChange}
            className="mb-4"
            isInvalid={formik.touched.state && !!formik.errors.state}
            errorMsg={formik.errors.state}
            onBlur={formik.handleBlur}
            validation
          />
        </div>
      </div>
      <Form.Default
        id="zipCode"
        label="Zip Code"
        placeholder="Enter zip code"
        value={formik.values.zipCode}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.zipCode && !!formik.errors.zipCode}
        errorMsg={formik.errors.zipCode}
        onBlur={formik.handleBlur}
        type="number"
        maxLength={5}
        validation
      />
      <div className="mt-5">
        <Button.Default
          id="buttonCompanyInfo"
          type="submit"
          label="Register"
          className="fw-bold"
          loading={isLoading}
        />
      </div>
    </form>
  );
}

export default FormsCompanyInfo;
